import Api from 'api';
import { GET_DASHBOARD, RESET_DASHBOARD } from 'containers/dashboard/constants';

export const getDashboard = (companyId, subcompanyId) => ({
  type: GET_DASHBOARD,
  meta: { needAuth: true },
  payload: Api.dashboard.get(companyId, subcompanyId),
});

export const resetDashboard = () => ({ type: RESET_DASHBOARD });



// WEBPACK FOOTER //
// src/containers/dashboard/actions.js